var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRamAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 113,
    viewBox: "0 0 123 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.512 111.735L16.9725 122.555C12.2888 123.136 8.18604 119.614 7.89557 114.966L0.0167663 13.5221C-0.273697 8.83842 3.24817 5.0261 7.60511 4.73564L106.145 0.0519225C110.538 -0.23854 114.314 3.28332 114.641 7.64027L122.52 102.948C123.1 107.342 119.869 111.154 115.512 111.735Z",
    fill: "#001A3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.324 111.736L20.7848 122.556C16.1011 123.137 11.9983 119.615 11.7078 114.967L3.82902 13.487C3.53856 8.80327 7.06042 4.99095 11.4174 4.70048L109.957 0.0167663C114.35 -0.273697 118.126 3.24817 118.453 7.60511L126.332 102.913C126.949 107.343 123.718 111.155 119.324 111.736Z",
    fill: "#67B7FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9278 58.7252C33.0927 58.7252 32.4029 58.0717 32.3666 57.2366C32.294 56.3652 32.9475 55.5664 33.8552 55.4938L97.5029 50.6286C98.4106 50.5559 99.1731 51.2095 99.2457 52.1172C99.3183 52.9886 98.6648 53.7873 97.7571 53.86L34.1094 58.7252C34.0004 58.7252 33.9641 58.7252 33.9278 58.7252Z",
    fill: "#001A3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7438 73.7577C34.7271 73.7214 33.8558 72.9952 33.7105 71.9423L31.8588 58.0001C31.7136 56.8382 32.5124 55.7853 33.6742 55.6401C34.8361 55.4948 35.889 56.2936 36.0342 57.4555L37.8859 71.3977C38.0312 72.5595 37.2324 73.6125 36.0705 73.7577C35.9616 73.7214 35.8527 73.7577 35.7438 73.7577Z",
    fill: "#001A3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3119 72.0876C67.2953 72.0513 66.4239 71.3251 66.2787 70.2722L62.1396 39.1563C61.9944 37.9945 62.7931 36.9416 63.955 36.7963C65.1168 36.6511 66.1698 37.4499 66.315 38.6117L70.4541 69.7276C70.5993 70.8894 69.8005 71.9424 68.6387 72.0876C68.5298 72.0876 68.4209 72.0876 68.3119 72.0876Z",
    fill: "#001A3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9923 69.3651C97.9757 69.3288 97.1043 68.6027 96.9591 67.5497L95.1074 53.6075C94.9621 52.4457 95.7609 51.3927 96.9228 51.2475C98.0846 51.1023 99.1375 51.901 99.2828 53.0629L101.134 67.0051C101.28 68.167 100.481 69.2199 99.3191 69.3651C99.2102 69.3651 99.1012 69.3651 98.9923 69.3651Z",
    fill: "#001A3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9795 92.5286L28.6637 94.0535C27.756 94.1261 26.9573 93.4363 26.921 92.5286L24.8514 73.9389C24.8151 73.0312 25.5413 72.3051 26.3763 72.2688L45.6921 70.6712C46.5635 70.6349 47.2897 71.3611 47.2897 72.1962L49.3592 90.8947C49.5044 91.7298 48.8509 92.456 47.9795 92.5286Z",
    fill: "#21409A",
    stroke: "#001A3C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.172 87.5188L92.8561 89.0437C91.9484 89.1163 91.1496 88.4265 91.1133 87.5188L89.0438 68.9292C89.0075 68.0215 89.7336 67.2953 90.5687 67.259L109.884 65.6615C110.756 65.6252 111.482 66.3513 111.482 67.1864L113.552 85.8849C113.661 86.72 113.007 87.4462 112.172 87.5188Z",
    fill: "#21409A",
    stroke: "#001A3C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7488 90.8606L60.433 92.3855C59.5253 92.4581 58.7266 91.7683 58.6902 90.8606L56.6207 72.271C56.5844 71.3633 57.3105 70.6371 58.1456 70.6008L77.4614 69.0033C78.3328 68.967 79.059 69.6931 79.059 70.5282L81.1285 89.2267C81.2374 90.0618 80.5839 90.788 79.7488 90.8606Z",
    fill: "#21409A",
    stroke: "#001A3C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5039 38.7942L54.1881 40.3191C53.2804 40.3917 52.4817 39.7019 52.4454 38.7942L50.3758 20.2046C50.3395 19.2969 51.0657 18.5707 51.9007 18.5344L71.2165 16.9369C72.0879 16.9005 72.8141 17.6267 72.8141 18.4618L74.8836 37.1603C74.9926 37.9954 74.339 38.7216 73.5039 38.7942Z",
    fill: "#21409A",
    stroke: "#001A3C",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamAnalysis);
export default __webpack_public_path__ + "static/media/RamAnalysis.8c5603fb750a538104a78582cd7eedf2.svg";
export { ForwardRef as ReactComponent };